import { render, staticRenderFns } from "./CopyLink.vue?vue&type=template&id=f63c79a6&scoped=true&"
import script from "./CopyLink.vue?vue&type=script&lang=ts&"
export * from "./CopyLink.vue?vue&type=script&lang=ts&"
import style0 from "./CopyLink.vue?vue&type=style&index=0&id=f63c79a6&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f63c79a6",
  null
  
)

export default component.exports